<template>
  <cms-banner-image-standard v-bind="$props" />
</template>

<script setup lang="ts">
import type { BannerImageContent } from '#types/components/cms/banner-image'

defineProps<{
  content: BannerImageContent
  paused?: boolean
  firstElement?: boolean
}>()
</script>
